import React, { forwardRef } from "react";
import FormField, {
  getControlClassName,
  pickTouched,
} from "components/fields/FormField";

/**
 * Multi-line text input with label, hint and error.
 *
 * Props:
 * - id (auto when omitted), label, required=false, hint, error, touched: see FormField.
 * - rows=4; vertically resizable.
 * - className: wrapper classes. labelClassName: extra label classes.
 * - value, onChange, onBlur, name, placeholder, disabled, maxLength, … : forwarded to the <textarea>.
 * - ref: forwarded to the <textarea>.
 */
const Textarea = forwardRef(function Textarea(props, ref) {
  const {
    id,
    label,
    required = false,
    hint,
    error,
    touched,
    rows = 4,
    className = "",
    labelClassName,
    ...rest
  } = props;

  return (
    <FormField
      id={id}
      label={label}
      required={required}
      hint={hint}
      error={error}
      {...pickTouched(props)}
      className={className}
      labelClassName={labelClassName}
    >
      {(controlProps) => (
        <textarea
          ref={ref}
          rows={rows}
          required={required}
          {...rest}
          {...controlProps}
          className={getControlClassName({
            invalid: controlProps["aria-invalid"],
            autoHeight: true,
            className: "block resize-y",
          })}
        />
      )}
    </FormField>
  );
});

export default Textarea;
